import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Thirtieththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Royal Velvet */
            --velvet: #4c1d95;    /* Violet 900 */
            --silk: #2e1065;      /* Violet 950 */
            --gold: #f59e0b;      /* Amber 500 */
            --silver: #e2e8f0;    /* Slate 200 */
            --text-light: #f3f4f6;
        }

        body { font-family: 'Playfair Display', serif; background: var(--silk); color: var(--text-light); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 40px; }
        
        .navbar { padding: 40px 0; border-bottom: 1px solid rgba(255,255,255,0.1); }
        .nav-inner { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 2rem; color: var(--gold); letter-spacing: 2px; text-transform: uppercase; }
        .nav-links { display: flex; gap: 40px; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 2px; }
        .nav-links a { color: var(--silver); text-decoration: none; transition: 0.3s; }
        .nav-links a:hover { color: var(--gold); }
        
        .hero { padding: 120px 0; text-align: center; background: radial-gradient(circle at center, #5b21b6 0%, #2e1065 70%); }
        .hero h1 { font-size: 5rem; margin-bottom: 30px; line-height: 1; color: white; text-shadow: 0 4px 20px rgba(0,0,0,0.5); }
        .hero p { font-size: 1.5rem; color: #ddd6fe; max-width: 700px; margin: 0 auto 50px; font-style: italic; font-family: 'Lora', serif; }
        
        .btn { background: transparent; color: var(--gold); border: 2px solid var(--gold); padding: 15px 40px; font-family: 'Playfair Display', serif; text-transform: uppercase; letter-spacing: 2px; transition: 0.3s; cursor: pointer; font-size: 1rem; }
        .btn:hover { background: var(--gold); color: var(--silk); box-shadow: 0 0 30px rgba(245, 158, 11, 0.4); }
        
        .section-separator { text-align: center; padding: 80px 0 40px; }
        .icon-flourish { font-size: 2rem; color: var(--gold); opacity: 0.5; }
        
        .card-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; }
        @media(max-width: 900px) { .card-grid { grid-template-columns: 1fr; } }
        
        .card { background: rgba(255,255,255,0.05); padding: 50px 30px; text-align: center; border: 1px solid rgba(255,255,255,0.1); transition: 0.3s; }
        .card:hover { background: rgba(255,255,255,0.08); border-color: var(--gold); transform: translateY(-5px); }
        .card-title { font-size: 1.8rem; margin: 20px 0; color: white; }
        
        .product-card { background: white; color: var(--silk); }
        .product-img { background: #eee; height: 250px; width: 100%; object-fit: cover; }
        .product-info { padding: 30px; text-align: center; }
        
        .footer { border-top: 1px solid rgba(255,255,255,0.1); padding: 80px 0; text-align: center; color: #94a3b8; font-family: 'Lora', serif; margin-top: 100px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Lora:ital@1&family=Playfair+Display:wght@400;700&display=swap" rel="stylesheet" />

            <div className="navbar">
                <div className="container nav-inner">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#store">Store</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </div>

            <div className="hero">
                <div className="container">
                    <h1>Sovereign<br/>Standard.</h1>
                    <p>Where luxury meets service. We provide an elite experience for those who demand nothing but the best.</p>
                    <a href="#store" className="btn">View Collection</a>
                </div>
            </div>

            <div className="container" id="services">
                <div className="section-separator"><span className="icon-flourish">❦</span></div>
                <div className="card-grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                            <div style={{fontSize: '2rem', color: 'var(--gold)'}}>
                                {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px'}} alt=""/> : <span>⚜</span>}
                            </div>
                            <h3 className="card-title">{item.name}</h3>
                            <p style={{fontFamily: 'Lora, serif', color: '#cbd5e1', lineHeight: 1.6}}>{item.description}</p>
                            <div style={{display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '20px'}}>
                                <a href={`tel:${get_data.mobile}`} style={{color: 'var(--gold)', border: '1px solid var(--gold)', padding: '5px 15px', fontFamily: 'Playfair Display, serif'}}>CALL</a>
                                <a href="#contact" style={{background: 'var(--gold)', color: 'var(--silk)', padding: '5px 15px', fontFamily: 'Playfair Display, serif'}}>ENQUIRE</a>
                            </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="container" id="store">
                <div className="section-separator"><span className="icon-flourish">❦</span></div>
                 <div className="card-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                             {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                             <div className="product-info">
                                 <h3 style={{fontSize: '1.4rem', margin: '0 0 10px'}}>{item.service_name}</h3>
                                 {item.price && <div style={{color: 'var(--velvet)', fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '20px'}}>₹{item.price}</div>}
                                 <button onClick={() => addToCart(item)} className="btn" style={{borderColor: 'var(--velvet)', color: 'var(--velvet)', fontSize: '0.8rem', padding: '10px 25px'}}>Acquire</button>
                             </div>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <h2 style={{fontSize: '2.5rem', marginBottom: '20px', fontFamily: 'Playfair Display, serif', color: 'white'}}>{get_data.service_name}</h2>
                <p>{get_data.business_location_name}</p>
                <div style={{marginTop: '30px', fontSize: '0.9rem'}}>
                    &copy; {new Date().getFullYear()}. An Estate of Excellence.
                </div>
            </footer>
        </>
    );
};

export default Thirtieththeme;
